@if (!isAccessFlagLoading && !isUrlVerified) {
  <app-url-verification
    [hasAccess]="gmailAddInAccessEnabled"
    [noAccessMessage]="featureFlagErrorText | translate"
    [tenantApiBaseUrl]="tenantService.BASE_URL"
    (successfulVerificationEvent)="onSuccessfulVerification()"
    (mustSignOutEvent)="signOut()"
  ></app-url-verification>
} @else {
  @if (!isLoading && authToken) {
    <app-banner
      class="w-full flex-shrink-0"
      [title]="'sendToEtrieve' | translate"
      [user]="user"
      [isWebApps]="isWebApps"
      (changeContentUrlEvent)="changeContentUrl()"
    >
    </app-banner>
    <div class="capture-container">
      <app-capture
        parentType="gmail"
        (restartFilingEvent)="close()"
      ></app-capture>
    </div>
    <p-toast
      position="bottom-right"
      key="errorToast"
      class="error-toast"
    >
      <ng-template
        let-message
        pTemplate="message"
      >
        <div class="toast-message-container">
          <div class="icon-container">
            <i class="fa-solid fa-circle-exclamation"></i>
          </div>
          <div class="message-container">
            <span class="message-summary">{{ message.summary | translate }}</span>
            <span>{{ message.detail | translate }}</span>
            @if (message.data) {
              <span>{{ message.data }}</span>
            }
          </div>
        </div>
      </ng-template>
    </p-toast>
  }
}
